import React, { useState } from "react";
import style from "./style.module.scss";
import LoadingWrapper from "components/LoadingWrapper";
import ListItem from "../ListItem";
import { Col, Modal, Row } from "antd";
import AddBtn from "../AddBtn";
import ModalAdd from "../ModalAdd";
import {
    examCancel,
    ExamListItem,
    examPublish,
    ExamType,
    getCurrentTime,
    getExamCourseList,
    getExamList
} from "service/exam";
import useRequest from "utils/useRequest";
import { useHistory } from "react-router-dom";
import { errorMessage, isTrue } from "service/service";
import { ResultMessage } from "components/ResultMessage";

export default function TabExamList() {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);

    const [examList, { loading }, loadExamList] = useRequest(() =>
        getExamList()
    );
    const [courseList, { loading: loadingCourseList }] = useRequest(() =>
        getExamCourseList()
    );
    const [currentTime, { loading: loadingTime }] = useRequest(() =>
        getCurrentTime()
    );
    const [currentData, setCurrentData] = useState<ExamListItem>();

    function onSaveOk() {
        loadExamList();
        setShowModal(false);
        setCurrentData(undefined);
    }

    function onCancel() {
        setShowModal(false);
        setCurrentData(undefined);
    }

    function onEdit(item: ExamListItem) {
        setCurrentData(item);
        setShowModal(true);
    }

    async function onAddPaper(item: ExamListItem, readonly: string = "0") {
        if (item.type === ExamType.Thesis) {
            history.push(`/exam/thesis/add/${item.examId}/${readonly}`);
        } else {
            history.push(`/exam/add/${item.examId}/${readonly}`);
        }
    }

    async function onPublish(exam: ExamListItem) {
        const { examId, isPublish, startTime, endTime } = exam;

        if (!startTime || !endTime) {
            return Modal.error({ content: "请设置考试时间" });
        }

        try {
            await (isTrue(isPublish)
                ? examCancel(examId)
                : examPublish(examId));
            loadExamList();
        } catch (e) {
            return ResultMessage.error(errorMessage(e));
        }
    }

    // 去判卷
    function onReview(item: ExamListItem) {
        switch (item.type) {
            case ExamType.Exam:
            case ExamType.Thesis:
                history.push(`/exam/review/${item.examId}`);
                break;
            case ExamType.Oral:
                history.push(`/exam/oral/review/${item.examId}`);
                break;
        }
    }

    function onPreview(item: ExamListItem) {
        history.push(`/exam/preview/${item.examId}/${item.type}`);
    }

    function onSupervise(item: ExamListItem) {
        history.push(`/exam/supervise/${item.examId}`);
    }

    return (
        <LoadingWrapper
            isEmpty={!examList || !courseList || !currentTime}
            loading={loading || loadingCourseList || loadingTime}>
            {() => (
                <div className={style.root}>
                    <h1 className={style.notice}>
                        备注：发布考核后，学生会看到该考核。考核时间到了，学生才能打开试卷。
                    </h1>
                    <h1 className={style.title}>考试科目</h1>

                    <Row gutter={[30, 30]}>
                        <Col span={8}>
                            <AddBtn onClick={() => setShowModal(true)} />
                        </Col>
                        {examList!.map(item => (
                            <Col span={8} key={item.examId}>
                                <ListItem
                                    {...item}
                                    currentTime={currentTime!}
                                    onEdit={() => onEdit(item)}
                                    onAdd={() => onAddPaper(item)}
                                    onPublish={() => onPublish(item)}
                                    onReview={() => onReview(item)}
                                    onPreview={() => onPreview(item)}
                                    onSupervise={() => onSupervise(item)}
                                />
                            </Col>
                        ))}
                    </Row>

                    {showModal && (
                        <ModalAdd
                            visible={showModal}
                            courseList={courseList!}
                            onCancel={onCancel}
                            onOk={onSaveOk}
                            data={currentData}
                        />
                    )}
                </div>
            )}
        </LoadingWrapper>
    );
}
